"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openPopupWindow = openPopupWindow;

/**
 * @param {string} url
 * @param {string} windowName
 * @param {number} width
 * @param {number} height
 * @returns {WindowProxy | null}
 */
function openPopupWindow(url, windowName) {
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 700;
  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
  return window.open(url, windowName, "toolbar=yes,location=yes,top=50,left=100,width=".concat(width, ",height=").concat(height));
}